module.exports = __webpack_public_path__ + "img/intercos.1e710de9.png";